/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import NoteDialog from './NoteDialog/index'
import React from 'react'
import Tysiav2NoteFilled from 'DesignSystem/Svgs/Tysiav2NoteFilled/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note",
  triggerRef,
  onMouseEnterTrigger,
  onMouseMoveTrigger,
  onMouseLeave,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Note.Vertical"
  data-view-path={viewPath}
 ref={triggerRef}
 onMouseEnter={onMouseEnterTrigger}
 onMouseMove={onMouseMoveTrigger}
 onMouseLeave={onMouseLeave}
 style={{'--bc-1-aI8I': hovered ? "#f9e19a" : "#F8E3A3"}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2NoteFilled
  viewPath={`${viewPath}/Tysiav2NoteFilled`}
 fill="#C99A2E"
 width={12}
 height={12}
/>
</div>
<NoteDialog
  viewPath={`${viewPath}/NoteDialog`}
 top={top}
 left={left}
 isOpen={hovered}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
 onMouseLeave={onMouseLeave}
/>
{children}
</React.Fragment>)
}